/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "./Callout3D.js";
import e from "./LineCallout3D.js";

function r(t) {
  if (!t) return !1;
  var e = t.verticalOffset;
  return !!e && !(e.screenLength <= 0 || e.maxWorldLength <= 0);
}

function n(t) {
  if (!t) return !1;
  if (!t.supportsCallout || !t.supportsCallout()) return !1;
  var e = t.callout;
  return !!e && !!e.visible && !!r(t);
}

function o(t) {
  return "point-3d" === t.type || "label-3d" === t.type;
}

var l = {
  types: {
    key: "type",
    base: t,
    typeMap: {
      line: e
    }
  },
  json: {
    write: !0
  }
};
export { l as calloutProperty, n as hasVisibleCallout, r as hasVisibleVerticalOffset, o as isCalloutSupport };